// LAB-002 : types d'échantillons (mêmes clés que config/labo.php côté Clinique) et étiquettes imprimables.
export const TYPES_ECHANTILLONS = [
    { id: 'sang', libelle: 'Sang' },
    { id: 'urine', libelle: 'Urine' },
    { id: 'selles', libelle: 'Selles' },
    { id: 'lcr', libelle: 'Liquide céphalo-rachidien' },
    { id: 'prelevement_local', libelle: 'Prélèvement local (écouvillon, pus…)' },
    { id: 'autre', libelle: 'Autre' }
]

// LAB-003 : motifs de réserve ou de rejet (mêmes clés que config/labo.php)
export const MOTIFS_REJET = [
    { id: 'hemolyse', libelle: 'Échantillon hémolysé' },
    { id: 'quantite_insuffisante', libelle: 'Quantité insuffisante' },
    { id: 'tube_inadapte', libelle: 'Tube ou contenant inadapté' },
    { id: 'non_identifie', libelle: 'Échantillon non identifié ou mal identifié' },
    { id: 'delai_depasse', libelle: 'Délai d\'acheminement dépassé' },
    { id: 'autre', libelle: 'Autre motif' }
]

// LAB-002-B : contenants de prélèvement de repli (le référentiel de la Clinique prime quand il est chargé).
// Le raccord au stock (emplacement de dotation) est un chantier logistique ultérieur : aucune consommation ici.
export const CONTENANTS_DEFAUT = [
    { code: 'tube_edta', libelle: 'Tube EDTA (bouchon violet)', type_echantillon: 'sang' },
    { code: 'tube_sec', libelle: 'Tube sec (bouchon rouge)', type_echantillon: 'sang' },
    { code: 'tube_citrate', libelle: 'Tube citraté (bouchon bleu)', type_echantillon: 'sang' },
    { code: 'tube_heparine', libelle: 'Tube hépariné (bouchon vert)', type_echantillon: 'sang' },
    { code: 'tube_fluorure', libelle: 'Tube fluorure (bouchon gris)', type_echantillon: 'sang' },
    { code: 'flacon_urine', libelle: 'Flacon urinaire stérile', type_echantillon: 'urine' },
    { code: 'pot_selles', libelle: 'Pot à selles', type_echantillon: 'selles' },
    { code: 'tube_lcr', libelle: 'Tube stérile LCR', type_echantillon: 'lcr' },
    { code: 'ecouvillon', libelle: 'Écouvillon de prélèvement', type_echantillon: 'prelevement_local' },
    { code: 'autre', libelle: 'Autre contenant', type_echantillon: null }
]

export function contenants_pour_type(type, contenants) {
    const liste = Array.isArray(contenants) && contenants.length ? contenants : CONTENANTS_DEFAUT
    return liste.filter(contenant => !contenant.type_echantillon || contenant.type_echantillon === type)
}

export function contenant_par_defaut(type, contenants, prefere) {
    const liste = contenants_pour_type(type, contenants)
    if (prefere && liste.some(contenant => contenant.code === prefere)) return prefere
    return liste.length ? liste[0].code : 'autre'
}

export function libelle_contenant(code, contenants) {
    if (!code) return ''
    const liste = Array.isArray(contenants) && contenants.length ? contenants : CONTENANTS_DEFAUT
    const trouve = liste.filter(contenant => contenant.code === code)
    return trouve.length ? trouve[0].libelle : String(code)
}

export function libelle_type_echantillon(type) {
    const trouve = TYPES_ECHANTILLONS.filter(item => item.id === type)
    return trouve.length ? trouve[0].libelle : (type ? String(type) : 'Non précisé')
}

function echapper(valeur) {
    return String(valeur === null || valeur === undefined ? '' : valeur)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

export function date_heure_etiquette(value) {
    if (!value) return ''
    const texte = String(value).replace('T', ' ')
    const morceaux = texte.split(' ')
    const date = morceaux[0].split('-')
    if (date.length !== 3) return texte
    const heure = morceaux.length > 1 ? morceaux[1].substr(0, 5) : ''
    return date[2] + '/' + date[1] + '/' + date[0] + (heure ? ' ' + heure : '')
}

/**
 * Document HTML autonome des étiquettes d'un bon : une étiquette par échantillon
 * (code, patient, date et heure de prélèvement, type, contenant, bon). Aucune donnée
 * autre que celles nécessaires à l'identification ISO 15189 de l'échantillon.
 */
export function etiquettes_html(entete, echantillons) {
    const lignes = (Array.isArray(echantillons) ? echantillons : []).map((echantillon) => {
        return '<div class="etiquette">'
            + '<div class="code">' + echapper(echantillon.code) + '</div>'
            + '<div class="patient">' + echapper(entete.patient) + '</div>'
            + '<div class="ligne">' + echapper(libelle_type_echantillon(echantillon.type_echantillon))
            + (echantillon.contenant ? ' · ' + echapper(echantillon.contenant) : '') + '</div>'
            + '<div class="ligne">Prélevé le ' + echapper(date_heure_etiquette(echantillon.preleve_at)) + '</div>'
            + '<div class="ligne">Bon ' + echapper(entete.reference) + (entete.etablissement ? ' · ' + echapper(entete.etablissement) : '') + '</div>'
            + '</div>'
    }).join('')
    return '<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><title>Étiquettes ' + echapper(entete.reference) + '</title>'
        + '<style>'
        + 'body{font-family:Arial,Helvetica,sans-serif;margin:8mm;color:#000}'
        + '.etiquette{display:inline-block;vertical-align:top;width:62mm;min-height:32mm;border:1px dashed #999;border-radius:2mm;padding:3mm;margin:0 3mm 3mm 0;box-sizing:border-box;page-break-inside:avoid}'
        + '.code{font-size:15pt;font-weight:bold;letter-spacing:.5px;margin-bottom:1.5mm}'
        + '.patient{font-size:11pt;font-weight:bold;margin-bottom:1mm}'
        + '.ligne{font-size:9pt;line-height:1.35}'
        + '@media print{.etiquette{border-color:#ccc}}'
        + '</style></head><body>' + lignes + '</body></html>'
}

/**
 * Ouvre la fenêtre d'impression des étiquettes (navigateur). Sans fenêtre disponible, ne fait rien.
 */
export function imprimer_etiquettes(entete, echantillons) {
    if (typeof window === 'undefined' || typeof window.open !== 'function') return false
    const fenetre = window.open('', '_blank', 'width=900,height=700')
    if (!fenetre) return false
    fenetre.document.open()
    fenetre.document.write(etiquettes_html(entete, echantillons))
    fenetre.document.close()
    fenetre.focus()
    fenetre.print()
    return true
}
